import { PeriodProvider } from "@/providers/Period";
import { HiCubeTransparent } from "react-icons/hi";
import { MdOutlinePlaylistAdd } from "react-icons/md";
import { Outlet } from "react-router-dom";
import { lazy } from "react";

const ListCarga = lazy(() => import("./Carga/create"));
const ListCarregamento = lazy(() => import("./Carregamento/create"));
const ClientErp = lazy(() => import("./Cliente").then((m) => ({ default: m.ClientErp })));
const CadastrarCliente = lazy(() => import("./Cliente/components/CadastrarCliente").then((m) => ({ default: m.CadastrarCliente })));
const Container = lazy(() => import("./ContainerPage"));
const FilialFakeErpComponent = lazy(() => import("./Filial"));
const FornecedoresFakeErp = lazy(() => import("./Fornecedores"));
const GrupoErp = lazy(() => import("./grupo").then((m) => ({ default: m.GrupoErp })));
const AddGrupo = lazy(() => import("./grupo/create").then((m) => ({ default: m.AddGrupo })));
const EditGrupo = lazy(() => import("./grupo/FormEdit/edit").then((m) => ({ default: m.EditGrupo })));
const NotaItensERPComponentV2 = lazy(() => import("./NotaItens"));
const FormItemNota = lazy(() => import("./NotaItens/FormItemNota").then((m) => ({ default: m.FormItemNota })));
const ImportNotaItem = lazy(() => import("./NotaItens/ImportNotaItem"));
const NotaERPComponent = lazy(() => import("./Notas"));
const ModalCadastroDeNotas = lazy(() => import("./Notas/Components/ModalCadastroDeNotas").then((m) => ({ default: m.ModalCadastroDeNotas })));
const PedidoErp = lazy(() => import("./Pedido").then((m) => ({ default: m.PedidoErp })));
const Form = lazy(() => import("./Pedido/children/form").then((m) => ({ default: m.Form })));
const ItensPedido = lazy(() => import("./Pedido/children/itens").then((m) => ({ default: m.ItensPedido })));
const PedidoItensErp = lazy(() => import("./PedidoItens").then((m) => ({ default: m.PedidoItensErp })));
const ProductFakeErp = lazy(() => import("./Products/create").then((m) => ({ default: m.ProductFakeErp })));
const SubGrupoErp = lazy(() => import("./subGrupo").then((m) => ({ default: m.SubGrupoErp })));
const AddSubGrupo = lazy(() => import("./subGrupo/add").then((m) => ({ default: m.AddSubGrupo })));
const EditSubGrupo = lazy(() => import("./subGrupo/FormEdit/edit").then((m) => ({ default: m.EditSubGrupo })));
const TransportadoraErp = lazy(() => import("./Transportadora").then((m) => ({ default: m.TransportadoraErp })));
const VeiculosErp = lazy(() => import("./Veiculos"));

export const ModuleFakeErp = {
  menuItem: {
    to: "/fakerp",
    title: "ERP",
    id: 12,
    icon: HiCubeTransparent,
    childrens: [
      {
        to: "/fakerp/filial-erp",
        title: "Filial",
        fullTitle: "Cadastro de Filial",
        icon: MdOutlinePlaylistAdd,
        id: 64,
      },
      {
        to: "/fakerp/cadastro-de-fornecedores",
        title: "Fornecedor",
        fullTitle: "Cadastro de Fornecedor",
        icon: MdOutlinePlaylistAdd,
        id: 65,
      },
      {
        to: "/fakerp/cadastro-de-grupo",
        title: "Grupo",
        fullTitle: "Cadastro de Grupo",
        icon: MdOutlinePlaylistAdd,
        id: 66,
      },
      {
        to: "/fakerp/cadastro-de-subgrupo",
        title: "SubGrupo",
        fullTitle: "Cadastro de SubGrupo",
        icon: MdOutlinePlaylistAdd,
        id: 67,
      },
      {
        to: "/fakerp/cadastro-de-produto",
        title: "Produtos",
        fullTitle: "Cadastro de Produtos",
        icon: MdOutlinePlaylistAdd,
        id: 68,
      },
      {
        to: "/fakerp/cadastro-de-cliente",
        title: "Clientes",
        fullTitle: "Cadastro de Cliente",
        icon: MdOutlinePlaylistAdd,
        id: 69,
      },
      {
        to: "/fakerp/cadastro-de-transportadora",
        title: "Transportadora",
        fullTitle: "Cadastro de Transportadora",
        icon: MdOutlinePlaylistAdd,
        id: 70,
      },
      {
        to: "/fakerp/cadastro-veiculo",
        title: "Veículo",
        fullTitle: "Cadastro de Veículo",
        icon: MdOutlinePlaylistAdd,
        id: 71,
      },
      {
        hasDivider: true,
        to: "/fakerp/cadastro-de-carga",
        title: "Carga Entrada",
        fullTitle: "Cadastro de Carga",
        icon: MdOutlinePlaylistAdd,
        id: 72,
      },
      {
        to: "/fakerp/cadastro-de-nota",
        title: "Nota",
        fullTitle: "Cadastro de Nota",
        icon: MdOutlinePlaylistAdd,
        id: 73,
      },
      {
        hasDivider: true,
        to: "/fakerp/cadastro-de-carregamento",
        title: "Carga Saida",
        fullTitle: "Cadastro de Carregamento",
        icon: MdOutlinePlaylistAdd,
        id: 74,
      },
      {
        to: "/fakerp/pedido",
        title: "Pedidos",
        fullTitle: "Cadastro de Pedidos",
        icon: MdOutlinePlaylistAdd,
        id: 75,
      },
      {
        hasDivider: true,
        to: "/fakerp/importacao-container",
        title: "Container",
        fullTitle: "Importar Container",
        icon: MdOutlinePlaylistAdd,
        id: 82,
      },
    ],
  },

  routes: [
    {
      path: "/fakerp",
      element: <></>,
    },
    {
      path: "/fakerp/cadastro-de-carga",
      element: <ListCarga />,
    },
    {
      path: "/fakerp/cadastro-de-produto",
      element: <ProductFakeErp />,
    },
    {
      path: "/fakerp/pedido",
      element: <PedidoErp />,
      children: [
        {
          path: ":id",
          element: <ItensPedido />,
        },
        {
          path: "create",
          element: <Form />,
        },
      ],
    },
    {
      path: "/fakerp/pedido-itens",
      element: <PedidoItensErp />,
      children: [
        {
          path: ":id",
          element: <PedidoItensErp />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-fornecedores",
      element: <FornecedoresFakeErp />,
    },
    {
      path: "/fakerp/cadastro-de-carregamento",
      element: <ListCarregamento />,
    },
    {
      path: "/fakerp/cadastro-veiculo",
      element: <VeiculosErp />,
    },
    {
      path: "/fakerp/filial-erp",
      element: <FilialFakeErpComponent />,
    },
    {
      path: "/fakerp/cadastro-de-nota",
      element: (
        <PeriodProvider>
          <NotaERPComponent />
        </PeriodProvider>
      ),
      children: [
        {
          path: "create",
          element: <ModalCadastroDeNotas />,
        },
        {
          path: ":id",
          element: <ModalCadastroDeNotas />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-itens-nota/:id",
      element: (
        <PeriodProvider>
          <NotaItensERPComponentV2 />
        </PeriodProvider>
      ),
      children: [
        {
          path: "create",
          element: <FormItemNota />,
        },
        {
          path: ":iditens",
          element: <FormItemNota />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-itens-nota/:id/create/importProcessor",
      element: (
        <PeriodProvider>
          <ImportNotaItem />
        </PeriodProvider>
      ),
    },
    {
      path: "/fakerp/cadastro-de-cliente",
      element: <ClientErp />,
      children: [
        {
          path: "create",
          element: <CadastrarCliente />,
        },
        {
          path: ":id",
          element: <CadastrarCliente />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-grupo",
      element: (
        <>
          <Outlet />
        </>
      ),
      children: [
        {
          path: "",
          element: <GrupoErp />,
        },
        {
          path: "create",
          element: <AddGrupo />,
        },
        {
          path: ":id",
          element: <EditGrupo />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-subgrupo",
      element: (
        <>
          <Outlet />
        </>
      ),
      children: [
        {
          path: "",
          element: <SubGrupoErp />,
        },
        {
          path: "create",
          element: <AddSubGrupo />,
        },
        {
          path: ":id",
          element: <EditSubGrupo />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-transportadora",
      element: <TransportadoraErp />,
    },
    {
      path: "/fakerp/importacao-container",
      element: <Container />,
    },
  ],
};
